import { type EventParams, GA4Event } from '@/libs/ga4';
import { sendEvent } from '@/libs/ga4/functions/send-event';

export function ga4_infoPage({ user, content_group }: EventParams) {
  sendEvent(
    GA4Event.InfoPage,
    {
      items: undefined,
    },
    {
      content_group,
      user,
    },
  );
}
